import { useNavigate } from "react-router-dom";
import "../styles/main.css";

export default function Reports(){

const navigate = useNavigate();

return(

<div className="mobile-app">

<div className="page-header">
<h2>Reports</h2>
</div>

<div className="section">

<div className="grid">

<div className="card" onClick={()=>navigate("/daily-sales")}>
📊
<p>Daily Sales</p>
</div>

<div className="card" onClick={()=>navigate("/monthly-sales")}>
📈
<p>Monthly Sales</p>
</div>

<div className="card" onClick={()=>navigate("/stock-report")}>
📦
<p>Stock Report</p>
</div>

<div className="card" onClick={()=>navigate("/ledger")}>
📒
<p>Ledger</p>
</div>

<div className="card" onClick={()=>navigate("/day-book")}>
📑
<p>Day Book</p>
</div>

</div>

</div>

</div>

)

}